module.exports = __webpack_public_path__ + "static/media/gradient.857e958b.svg";